export const sortByName = (data:any) => {
	data?.sort((a:any, b:any):any=>{
        if( a.value < b.value) {
            return -1
        }
        if( a.value > b.value) {
            return 1
        }
        return 0
    })
    return data
}
